export const getPositionSegmentEdges = (
  position: number,
  maxDistance: number,
  min?: number,
  max?: number
): { borderLeft: number; borderRight: number } => {
  const res = {
    borderLeft: position,
    borderRight: position,
  };
  res.borderLeft = position - Math.round(maxDistance / 2);
  if (typeof min !== "undefined" && res.borderLeft < min) {
    res.borderLeft = min;
  }
  res.borderRight = res.borderLeft + maxDistance;
  if (typeof max !== "undefined" && res.borderRight > max) {
    res.borderRight = max;
  }

  return res;
};
